import axios from "axios";

const httpService = {
  get: axios.get,
  post: axios.post,
  axios
};

export default httpService;
